var React = require('react');
var DatePicker =
  require('react-datepicker').default || require('react-datepicker');
var { useTranslation } = require('react-i18next');
var dayjs = require('../../../utils/dayjsConfig');
require('react-datepicker/dist/react-datepicker.css');

// inputProps => { id, required, disabled }
const DayPickerInput = ({
  value,
  onChange,
  dateFormat = 'YYYY-MM-DD',
  dayPickerProps,
  inputProps,
  isValidDate = () => true,
}) => {
  const { t } = useTranslation();

  // Convert value from dayjs/string to Date object
  const dateValue = value
    ? dayjs(value).isValid()
      ? dayjs(value).toDate()
      : null
    : null;

  // Handle onChange - convert Date back to dayjs format
  const handleChange = (date) => {
    if (onChange) {
      // react-datepicker passes Date object or null
      if (date) {
        // Convert Date to dayjs and format according to dateFormat
        const formatted = dayjs(date).format(dateFormat);
        onChange(formatted);
      } else {
        onChange(null);
      }
    }
  };

  // Filter dates based on isValidDate function
  const filterDate = (date) => {
    return isValidDate(dayjs(date));
  };

  // Convert dayjs format to react-datepicker format
  // react-datepicker uses: yyyy for year, MM for month, dd for day
  const convertDateFormat = (format) => {
    return format
      .replace(/YYYY/g, 'yyyy')
      .replace(/YY/g, 'yy')
      .replace(/DD/g, 'dd')
      .replace(/D/g, 'd')
      .replace(/MM/g, 'MM')
      .replace(/M/g, 'M');
  };

  return (
    <DatePicker
      selected={dateValue}
      onChange={handleChange}
      dateFormat={convertDateFormat(dateFormat)}
      filterDate={filterDate}
      className={`form-control ${inputProps?.className || ''}`}
      placeholderText={t('choose_date')}
      autoComplete='off'
      popperProps={{ strategy: 'fixed' }}
      {...dayPickerProps}
      style={{
        width: '100%',
        ...inputProps?.style,
      }}
      {...inputProps}
    />
  );
};

module.exports = DayPickerInput;
